import { render, staticRenderFns } from "./BillingChangeRequestActivities.vue?vue&type=template&id=40f37296"
import script from "./BillingChangeRequestActivities.vue?vue&type=script&lang=ts"
export * from "./BillingChangeRequestActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports